<template>
  <header class="admin-header">
    <div>
      <div class="header-title">{{ pageTitle }}</div>
      <div class="header-subtitle">平台系统管理</div>
    </div>
    <div class="header-actions">
      <el-button size="small" @click="openFrontend">回到前台</el-button>
      <div class="user-role">{{ roleLabel }}</div>
      <div class="user-info" v-if="isAuthenticated">
        <span>{{ username }}</span>
        <span class="logout-link" @click="handleLogout">退出</span>
      </div>
    </div>
  </header>
</template>

<script>
import { authState, logout } from "@/services/auth";
import { isPlatformAdmin, isRagAdmin } from "@/services/adminAccess";

export default {
  name: "AdminHeader",
  computed: {
    isAuthenticated() {
      return !!(authState.session && authState.session.id);
    },
    username() {
      return authState.session && authState.session.user
        ? authState.session.user.username
        : "未登录";
    },
    roleLabel() {
      if (!(authState.session && authState.session.user)) {
        return "访客";
      }
      const user = authState.session.user;
      if (isPlatformAdmin(user)) {
        return "平台管理员";
      }
      return isRagAdmin(user) ? "RAG 管理员" : "普通用户";
    },
    pageTitle() {
      return (this.$route.meta && this.$route.meta.title) || "管理后台";
    },
  },
  methods: {
    openFrontend() {
      window.open("/home", "_blank", "noopener,noreferrer");
    },
    async handleLogout() {
      try {
        await logout();
        this.$message.success("已退出登录");
        this.$router.push("/home");
      } catch (error) {
        this.$message.error(error.message || "退出失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-header {
  height: 72px;
  background: #fff;
  border-bottom: 1px solid #eaecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.header-subtitle {
  margin-top: 6px;
  font-size: 12px;
  color: #98a2b3;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-role {
  padding: 8px 14px;
  border-radius: 999px;
  background: #313845;
  color: #fff;
  font-size: 13px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #464646;
}

.logout-link {
  color: #f78001;
  cursor: pointer;
}
</style>
